import { render, staticRenderFns } from "./PanelBookingDetails.vue?vue&type=template&id=6b0d7950&lang=pug&"
import script from "./PanelBookingDetails.vue?vue&type=script&lang=js&"
export * from "./PanelBookingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports